export default "__VITE_ASSET__D_eARl_e__"